import {
  AllQueuesData,
  Appointment,
  QUEUE_SORT_BY,
  QUEUE_TYPE,
  TQueueFilter,
} from "@elixir/types";
import dayjs from "dayjs";

export const defaultQueueFilters: TQueueFilter = {
  tags: [],
  services: [],
  paidStatus: [],
  reminderStatus: [],
  followupDate: [],
  followupStatus: [],
};

export function getQueueTypeFromKey(key: keyof AllQueuesData) {
  switch (key) {
    case "bookedAppointments":
      return QUEUE_TYPE.BOOKED;
    case "followupAppointments":
      return QUEUE_TYPE.FOLLOWUP;
    case "opdAppointments":
      return QUEUE_TYPE.CHECKED_IN;
    case "completedAppointments":
      return QUEUE_TYPE.COMPLETED;
    case "otherAppointments":
      return QUEUE_TYPE.OTHERS;
    case "requestedAppointments":
      return QUEUE_TYPE.REQUESTED;
    default:
      return key;
  }
}
export function getQueueKeyFromQueueType(
  key: QUEUE_TYPE | string
): keyof AllQueuesData {
  let _key: keyof AllQueuesData = "bookedAppointments";
  switch (key) {
    case QUEUE_TYPE.BOOKED:
      _key = "bookedAppointments";
      break;
    case QUEUE_TYPE.FOLLOWUP:
      _key = "followupAppointments";
      break;
    case QUEUE_TYPE.CHECKED_IN:
      _key = "opdAppointments";
      break;
    case QUEUE_TYPE.COMPLETED:
      _key = "completedAppointments";
      break;
    case QUEUE_TYPE.OTHERS:
      _key = "otherAppointments";
      break;
    case QUEUE_TYPE.REQUESTED:
      _key = "requestedAppointments";
      break;
  }
  return _key;
}

export const queueFilterInlineSearchKeys = [
  "patient.fln",
  "patient.mobile",
  "patient.health-ids",
  "uhid",
];

export const queueSortBy = (
  appointments: Appointment[],
  sortBy?: QUEUE_SORT_BY
): Appointment[] => {
  switch (sortBy) {
    case QUEUE_SORT_BY.TOKEN_NUMBER_LOW_TO_HIGH:
      return appointments.sort((a, b) => a.token! - b.token!);
    case QUEUE_SORT_BY.TOKEN_NUMBER_HIGH_TO_LOW:
      return appointments.sort((a, b) => b.token! - a.token!);
    case QUEUE_SORT_BY.APPOINTMENT_TIME_HIGH_TO_LOW:
      return appointments.sort((a, b) =>
        dayjs(b.start_time).diff(dayjs(a.start_time))
      );
    case QUEUE_SORT_BY.APPOINTMENT_TIME_LOW_TO_HIGH:
      return appointments.sort((a, b) =>
        dayjs(a.start_time).diff(dayjs(b.start_time))
      );
    case QUEUE_SORT_BY.WAITING_TIME_HIGH_TO_LOW:
      return appointments.sort((a, b) =>
        dayjs(a.visit_checkin).diff(dayjs(b.visit_checkin))
      );
    case QUEUE_SORT_BY.WAITING_TIME_LOW_TO_HIGH:
      return appointments.sort((a, b) =>
        dayjs(b.visit_checkin).diff(dayjs(a.visit_checkin))
      );
    case QUEUE_SORT_BY.VISIT_END_TIME_HIGH_TO_LOW:
      return appointments.sort((a, b) =>
        dayjs(a.visit_end).diff(dayjs(b.visit_end))
      );
    case QUEUE_SORT_BY.VISIT_END_TIME_LOW_TO_HIGH:
      return appointments.sort((a, b) =>
        dayjs(b.visit_end).diff(dayjs(a.visit_end))
      );
    default:
      return appointments;
  }
};
